import styled from 'styled-components';
import { darkgrey, grey } from 'styles/Colors';
import { StyledBpPlay } from './BpPlayComponent/BpPlayComponentStyles';
import { BpPlaceholderPlayWrapper } from './BpPlaceholderPlayStyles';

export const BpPlayListWrapper = styled.div`
  height: 100%;
  .MuiPaper-root {
    height: 100%;
    padding: 6px 5px !important;
    overflow: auto;
    display: block;
    @media screen and (-webkit-min-device-pixel-ratio: 0) {
      overflow: hidden;
      &:hover {
        overflow-y: scroll;
        ${StyledBpPlay},
        ${BpPlaceholderPlayWrapper} {
          margin-right: -2px;
        }
      }
      &::-webkit-scrollbar {
        width: 2px;
      }
      &::-webkit-scrollbar-track {
        border-radius: 3.5px;
      }
      &::-webkit-scrollbar-thumb {
        background-image: linear-gradient(179deg, ${darkgrey}, rgba(65, 65, 65, 0.82));
        border-radius: 3.5px;
      }
    }
  }
`;

export const BpPlayListPlaceholder = styled.div`
  width: 150px;
  padding: 5px;
  svg {
    display: block;
    margin: auto;
    margin-bottom: 10px;
  }
  span {
    font-family: Lato;
    line-height: 1.23;
    letter-spacing: 0.5px;
    color: ${grey};
    display: block;
  }
`;

export const PlaceholderText = styled.span`
  font-family: Lato;
  font-size: 13px;
  line-height: 1.23;
  letter-spacing: 0.5px;
  text-align: center;
  color: ${grey};
  display: block;
  margin-bottom: 30px;
`;

export const PlaceholderCard = styled.div`
  width: 81px;
  height: 53px;
  border-radius: 3px;
  border: solid 0.9px rgba(207, 207, 207, 0.7);
  margin: auto;
  padding: 7px;
  margin-bottom: 10px;
`;

export const UpperLabel = styled.div`
  width: 63px;
  height: 8px;
  border-radius: 3px;
  background-color: #d8d8d8;
  padding: 0;
`;

export const ScoreLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  padding: 0;
`;

export const LowerLabel = styled.div`
  width: 47px;
  height: 8px;
  border-radius: 3px;
  background-color: #eeeeee;
  padding: 0;
`;
